import { Component, OnInit } from '@angular/core';
import { ColDef, GridOptions,ICellRendererParams} from 'ag-grid-community';
import { Router,ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/Core/services/auth.service';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from 'src/app/Core/services/user.service';

@Component({
  selector: 'app-list-ota',
  templateUrl: './list-ota.component.html',
  styleUrls: ['./list-ota.component.css']
})
export class ListOTAComponent implements OnInit {

  
  gridOptions: GridOptions;
  columnDefs: ColDef[];
  rowData: any[];
  otaID:any;
  otaName:any;

  constructor(private http: HttpClient,private router: Router,private route: ActivatedRoute, private AuthService: AuthService, private userService: UserService) {
    this.gridOptions = {
      defaultColDef: {
        flex: 1,
        minWidth: 100,
        resizable: true,
      },
      
    };

  this.gridOptions = {
    defaultColDef: {
      flex: 1,
      minWidth: 100,
      resizable: true,
    },
  };

  this.columnDefs = [
    { headerName: 'ID', field: 'id' },
    { headerName: 'Job Name', field: 'job_name',
      cellRenderer: (params: ICellRendererParams) =>{
        const otaID =params.data.id || '';
        const otaName =params.data.job_name || '';
        return `<a href='OTA-upgrade/${otaID}'>${otaName}</a>` 
      }
    },
    { headerName: 'Description', field: 'description' },
    { headerName: 'Job Type', field: 'job_type' },
    { headerName: 'Created', field: 'created_at' },
    { headerName: 'Name', field: 'file_name' },
    { headerName: 'Model Type', field: 'model' },
    { headerName: 'Firmware version', field: 'firmware_version' },
    { headerName: 'Status', field: 'status' },
  ];
  
  this.rowData=[];
}

ngOnInit(): void {
  this.fetchOTAJobs();
}

fetchOTAJobs() {
  {
    this.userService.getOTAJobs().subscribe(
      (data: any) => {
        if (data != null) {
          this.rowData = data; // Set the rowData property after fetching the data
          console.log(this.rowData);
        }
      },
      (error: any) => {
        console.error('Error fetching member data:', error);
      }
    );
  }
    }


}
